import React from "react";
import CustomerDetailsField from "./customerField";
import DownloadField from "./downloadField";
import withStyles from "@material-ui/core/styles/withStyles";
import { Box, Grid, Hidden } from "@material-ui/core";
import { useStyles } from "../indexFormStyles";
import { NOT_AVAILABLE_TEXT } from "../../../constants/index";

function AssetDetailsForm({ form, downloadFile }) {
  return (
    <Box direction="column" style={{ width: "100%" }}>
      <Grid container spacing={2}>
        <Grid container item md={5} direction="column">
          <CustomerDetailsField label={"Brand"} value={form.phone_brand} />

          <CustomerDetailsField label={"Model"} value={form.phone_model} />

          <CustomerDetailsField label={"Color"} value={form.phone_color} />

          <CustomerDetailsField label={"Storage"} value={form.phone_storage} />

          <CustomerDetailsField label={"RAM"} value={form.phone_ram} />

          <CustomerDetailsField
            label={"IMEI Number"}
            value={form.imei_number}
          />

          <CustomerDetailsField
            label={"Invoice Amount"}
            value={form.invoice_amount}
          />

          {/* <CustomerDetailsField
            label={"Invoice Number"}
            value={form.invoice_number}
          /> */}

          {/* <CustomerDetailsField
            label={"Invoice Amount"}
            value={form.invoice_amount}
          /> */}

          {/* <CustomerDetailsField
            label={"Manufactured Date"}
            value={form.manufactured_date}
          /> */}

          {/* <CustomerDetailsField
            label={"Serial Number"}
            value={form.serial_number}
          /> */}
        </Grid>

        <Hidden smDown>
          <Grid container item md={2} direction="column"></Grid>
        </Hidden>

        <Grid container item md={5} direction="column">
          <CustomerDetailsField
            label={"Plan Name"}
            value={form.product_name}
          />

          {/* <CustomerDetailsField
            label={"Coverage Period"}
            value={form.coverage_period}
          /> */}

          <CustomerDetailsField
            label={"Coverage Duration"}
            value={
              form.start_date
                ? `${form.start_date} - ${form.end_date}`
                : NOT_AVAILABLE_TEXT
            }
          />

          {/* <DownloadField
            label={"Mobile Photo"}
            clickHandler={downloadFile}
            url={form.screen_photo_link}
          /> */}

          <DownloadField
            label={"Invoice Photo"}
            clickHandler={downloadFile}
            url={form.invoice_link}
          />

          <DownloadField
            label={"Plan Document"}
            clickHandler={downloadFile}
            url={form.policy_document}
            type={"pdf"}
            value={"Download"}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(AssetDetailsForm);
